export enum BookingStatus {
    CONFIRMED = "CONFIRMED",
    ERROR = "ERROR",
    UNAVAILABLE = "UNAVAILABLE",
    CANCELLED = "CANCELLED",
    PENDING = "PENDING",
    WAITING = "WAITING",
    CANCEL_WAITING = "CANCEL_WAITING",
    REFUSED = "REFUSED"
}